import React, { useEffect, useRef, useState } from "react";
import Icon from "@bonprix/pattern-library/templates/icon";

const PADDING_WITH_BORDER_WIDTH = 22;

export default function Toggle({
  className = "",
  active = false,
  disabled = false,
  dotted = false,
  email = false,
  strikeThrough = false,
  href,
  text,
  onClick,
  testRefs = {},
}) {
  const [style, setStyle] = useState(null);
  const toggleRef = useRef(null);
  const textRef = useRef(null);

  const TagType = href ? "a" : "div";
  const classNames =
    className +
    (active ? " is-active" : "") +
    (disabled ? " is-disabled" : "") +
    (dotted ? " is-dotted" : "") +
    (email ? " is-email" : "") +
    (strikeThrough ? " is-strike-through" : "");

  useEffect(() => {
    const textRect = textRef.current?.getBoundingClientRect();
    setStyle({
      width: textRect.width + PADDING_WITH_BORDER_WIDTH + "px",
      paddingLeft: 0,
      paddingRight: 0,
    });
  }, [text]);

  return (
    <TagType
      href={href}
      className={classNames}
      onClick={() => onClick()}
      {...testRefs}
      ref={toggleRef}
      style={style}
    >
      <ToggleContent
        text={text}
        email={email}
        strikeThrough={strikeThrough}
        textRef={textRef}
      />
    </TagType>
  );
}

function ToggleContent({ text, email, strikeThrough, textRef }) {
  if (!strikeThrough && !email) {
    return (
      <span className="toggle__text" ref={textRef}>
        {text}
      </span>
    );
  }

  if (email) {
    return (
      <>
        <span className="toggle__text" ref={textRef}>
          {text}
        </span>
        <Icon name="email" className="toggle__email" />
      </>
    );
  }

  return (
    <>
      <span className="toggle__text" ref={textRef}>
        {text}
      </span>
      {/* customized SVG */}
      <span className="toggle__strike-through-wrapper">
        <svg
          className="toggle__strike-through"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Icons"
          x="0px"
          y="0px"
          viewBox="0 0 120 120"
          style={{
            enableBackground: "new 0 0 120 120",
            width: "40px",
            height: "40px",
          }}
        >
          <rect
            x="-20"
            y="60"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -30.5097 64)"
            width="172"
            height="1.5"
          />
        </svg>
      </span>
    </>
  );
}
